import { SessionType } from "@/features/training/model/Training/TrainingDrill";

import { UserSummary } from "@/model/User/UserSummary";

export class TrainingDrillSession {
	Id: number;
	DrillId: number;
	Date: string;
	Information: string;
	Comment: string;
	Status: TrainingDrillSessionStatus;
	FinishDate: string;
	Responsible: UserSummary;
	KpiParameters: SessionKpi[];
	Standin?: boolean;
}

export class TrainingDrillSessionSummary {
	Id: number;
	Name: string;
	Date: Date;
	DrillId: number;
	Type: SessionType;
}

export class TrainingDrillSessionSummaryWithKpiValue {
	Id: number;
	Name: string;
	Date: Date;
	DrillId: number;
	KpiValue: number;
}

export class SessionKpi {
	Id: number;
	Name: string;
	Value: number;
	MaxValue: number;
}

export enum TrainingDrillSessionStatus {
	Active = "Active",
	Completed = "Completed",
	Archived = "Archived",
	Cancelled = "Cancelled",
}

export class CreateTrainingDrillSessionRequest {
	DrillId: number;
	Date: Date;
	ResponsibleId: number;
	Information: string;
}

export class UpdateTrainingDrillSessionRequest {
	Id: number;
	Date: string;
	ResponsibleId: number;
	Information: string;
	Comment: string;
	KpiParameters: SessionKpiRequest[];
	Standin?: boolean;
}

export class SessionKpiRequest {
	Id: number;
	Value: number;
}
